import React from "react";
import dashboardclasses from "../../dashboard.module.css";
import { useNavigate } from "react-router";
function BookingInfo({ orders, orderstatusformatter, dateformatter }) {
    const Navigate = useNavigate();
    return (
        <>
            <button
                className={dashboardclasses["backbutton"]}
                onClick={() => {
                    Navigate(-1);
                }}>
                Back
            </button>
            <header className={dashboardclasses["order-details-header"]}>
                <h3
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                    }}>
                    Booking Details{" "}
                    {orderstatusformatter(orders?.booking_status)}
                </h3>
                <div className={dashboardclasses["order-header-item"]}>
                    <h5>Offer ID</h5>

                    <p>#{orders.driver_offer_id}</p>
                </div>
                <div className={dashboardclasses["order-header-item"]}>
                    <h5>BOOKING DATE TIME</h5>

                    {orders.book_date_formatted}
                </div>
            </header>
            <div className={dashboardclasses["orders-form-invoice-wrapper"]}>
                <div className={dashboardclasses["orders-form-invoice"]}>
                    {/*   <div
                                            className={
                                                dashboardclasses[
                                                    "invoice-detail"
                                                ]
                                            }>
                                            <div
                                                className={
                                                    dashboardclasses[
                                                        "detail-status"
                                                    ]
                                                }>
                                                <span>Status:</span>
                                                {orders?.status !=
                                                    "AdminCanceled" &&
                                                orders?.status !=
                                                    "UserCanceled" &&
                                                orders?.status != "Delivered" &&
                                                orders.status !=
                                                    "Payment-Failed" ? (
                                                    <select
                                                        defaultValue={
                                                            orders.orderStatus
                                                        }
                                                        onChange={
                                                            statuschangehandler
                                                        }>
                                                        {" "}
                                                        <option
                                                            value=""
                                                            default>
                                                            Update status
                                                        </option>
                                                    
                                                        <option value="Delivered">
                                                            Delivered{" "}
                                                        </option>
                                                        <option value="AdminCanceled">
                                                            Admin Cancel{" "}
                                                        </option>
                                                    </select>
                                                ) : (
                                                    orderstatusformatter(
                                                        orders.status
                                                    )
                                                )}
                                            </div>
                                            {orders?.status ==
                                                "Payment-Success" && (
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-handler"
                                                        ]
                                                    }>
                                                    <span>Update Vendor:</span>
                                                    <select
                                                        name=""
                                                        id=""
                                                        style={{
                                                            height: "2rem",
                                                            border: "1px solid #ccc",
                                                        }}
                                                        defaultValue={""}
                                                        onChange={
                                                            changeHandler
                                                        }>
                                                        <option
                                                            value=""
                                                            disabled>
                                                            Update Vendor
                                                        </option>
                                                        {allVendorData?.map(
                                                            (item) => (
                                                                <option
                                                                    value={
                                                                        item.mobile
                                                                    }>
                                                                    {item.name}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            )}
                                        </div> */}

                    <div className={dashboardclasses["order-items"]}>
                        <header
                            className={
                                dashboardclasses["customer-info-header"]
                            }>
                            <h4>Driver Info</h4>
                        </header>

                        <div>
                            <div
                                className={dashboardclasses["order-item-data"]}>
                                <div className={dashboardclasses["order-date"]}>
                                    <h5>Name</h5>
                                    <h4>:</h4>
                                    <p>{orders.offer_driver_name}</p>
                                </div>

                                <div className={dashboardclasses["order-date"]}>
                                    <h5>Contact Number</h5>
                                    <h4>:</h4>
                                    <p>{orders.offer_driver_mobile}</p>
                                </div>
                                {/* <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>shop</h5>
                                                        <h4>:</h4>
                                                        <p> {orders.shop}</p>
                                                    </div> */}
                            </div>
                        </div>
                        <div className={dashboardclasses["order-item-data"]}>
                            <h4> Service Details</h4>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Pickup Location</h5>
                                <h4>:</h4>
                                <p>
                                    {orders?.pickup_address?.buildingName},
                                    {orders?.pickup_address?.areaName}
                                    <br />
                                    {orders?.pickup_address?.city},
                                    {orders?.pickup_address?.state}-
                                    {orders?.pickup_address?.pincode}
                                </p>
                            </div>
                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Drop Location</h5>
                                <h4>:</h4>
                                <p>
                                    {orders?.drop_address?.buildingName},
                                    {orders?.drop_address?.areaName}
                                    <br />
                                    {orders?.drop_address?.city},
                                    {orders?.drop_address?.state}-
                                    {orders?.drop_address?.pincode}
                                </p>
                            </div>

                            <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Distance</h5>
                                <h4>:</h4>
                                <p>{orders?.offer_distance}KM</p>
                            </div>
                            {/* <div
                                className={
                                    dashboardclasses["order-date-address"]
                                }>
                                <h5>Time</h5>
                                <h4>:</h4>
                                <p>{orders?.offer_time} M</p>
                            </div> */}
                            {orders?.booking_status == 4 && (
                                <div
                                    className={
                                        dashboardclasses["order-date-address"]
                                    }>
                                    <h5>Cancel Reason</h5>
                                    <h4>:</h4>
                                    <p>{orders?.cancel_reason} M</p>
                                </div>
                            )}
                        </div>

                        <div className={dashboardclasses["order-item-data"]}>
                            <h4> Payment Details </h4>

                            <div className={dashboardclasses["order-date"]}>
                                <h5>Grand Total</h5>
                                <h4>:</h4>

                                <p>₹ {orders.offer_grand_total}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BookingInfo;
